class ProductQuantity extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.ProductQuantity = this;
        this.minusButton = this.ProductQuantity.querySelector('.js-quantity-minus');
        this.plusButton = this.ProductQuantity.querySelector('.js-quantity-plus');
        this.quantitySelect = this.ProductQuantity.querySelector('.js-quantity-select');
        this.input = this.ProductQuantity.querySelector('input');
        this.mobileBreakpoint = 1024;

        this.bindEvents();
    }

    bindEvents() {
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        if (this.isMobile) {
            this.quantitySelect.addEventListener('change', () => {
                this.input.value = this.quantitySelect.value;
            });
        } else {
            this.minusButton.addEventListener('click', () => {
                this.decreaseQuantity();
            });
        
            this.plusButton.addEventListener('click', () => {
                this.increaseQuantity();
            });
        }
    }


    decreaseQuantity() {
        let currentValue = parseInt(this.input.value);
        if (currentValue > 1) {
        this.input.value = currentValue - 1;
        }
        this.updateButtonState();
    }

    increaseQuantity() {
        let currentValue = parseInt(this.input.value);
        let maxQuantity = parseInt(this.input.dataset.maxQuantity);
        if (currentValue < maxQuantity) {
            this.input.value = currentValue + 1;
        }
        this.updateButtonState();
    }

    updateButtonState() {
        let currentValue = parseInt(this.input.value);
        let maxQuantity = parseInt(this.input.dataset.maxQuantity);
        if (currentValue === 1) {
            this.minusButton.setAttribute('disabled', true);
        } else {
            this.minusButton.removeAttribute('disabled');
        }
        if (currentValue === maxQuantity) {
            this.plusButton.setAttribute('disabled', true);
        } else {
            this.plusButton.removeAttribute('disabled');
        }
    }
}

if (customElements.get('product-quantity') === undefined) {
    customElements.define('product-quantity', ProductQuantity);
}
